import { useInfiniteQuery } from '@tanstack/react-query';
import { concat } from 'lodash';

import { getDiaryComments } from '../../../../api/diary';
import { handleError } from '../../../common';
import { QueryKeys } from '../../../common/react-query/query-keys';
import { useAlertModal } from '../../hook';

const useDiaryCommentInfinityQuery = (diaryId: number) => {
  const { openAlertModal } = useAlertModal();

  const result = useInfiniteQuery({
    queryKey: QueryKeys.getDiaryComments(diaryId),
    queryFn: async ({ pageParam = 1 }) => {
      if (!diaryId) throw new Error('no diaryId');
      return (await getDiaryComments(diaryId, pageParam)).data;
    },
    initialPageParam: 1,
    getNextPageParam: ({ hasNext, currentPage }) =>
      hasNext ? currentPage + 1 : undefined,
    enabled: !!diaryId,
    meta: {
      onError: (e: unknown) =>
        handleError(openAlertModal, e, '집밥일기 댓글 불러오기'),
    },
  });

  const diaryComments =
    result.data?.pages
      .map((page) => page.items)
      .reduce((a, b) => concat(a, b), []) ?? [];
  const totalDiaryCount = result.data?.pages[0].totalCount ?? 0;

  return { ...result, diaryComments, totalDiaryCount };
};

export default useDiaryCommentInfinityQuery;
